import { FieldDef, IssueDetail } from "models/issue";
import { useMemo } from "react";
import { titleize } from "helpers/string";
import { ResolutionInfo } from "models/resolutions";
import GreenStatusButton from "components/Status/GreenStatusButton";
import { FiCheckCircle } from "react-icons/fi";
import { toEmailFieldName } from "features/Issues/helpers";
import { get } from "lodash";
import { Flex } from "@chakra-ui/react";
import UserFormFields from "features/Issues/Components/UserFormFields";
import { UserUpdateFormValues } from "components/Forms/UserUpdateForm";

export function missingEmailIssueType(issue: IssueDetail) {
  return `Missing "${issue?.context?.emailType ? `${titleize(issue?.context?.emailType)} ` : ""}"`;
}

export function expandedMissingEmailIssueType(issue: IssueDetail) {
  if (issue?.user?.fullName) {
    return `Missing ${issue?.user?.fullName}'s ${issue?.context?.emailType ? `${titleize(issue?.context?.emailType)} ` : ""}`;
  }
  return missingEmailIssueType(issue);
}

export function missingEmailValue(issue: IssueDetail) {
  const attribute = toEmailFieldName(issue?.context?.emailType);
  return get(issue?.user, attribute);
}

export function IssueModalInputFields({ issue }: { issue: IssueDetail }) {
  const value = missingEmailValue(issue);
  const emailFieldName = toEmailFieldName(issue?.context?.emailType) as keyof UserUpdateFormValues;
  const fields: FieldDef<UserUpdateFormValues>[] = useMemo(
    () => (emailFieldName ? [{ name: emailFieldName, label: titleize(issue?.context?.emailType) }] : []),
    [emailFieldName, issue?.context?.emailType],
  );
  return (
    <Flex direction="column" gap="2">
      {issue?.context?.userId && <UserFormFields userId={issue.context.userId} fieldsDefs={fields} issue={issue} />}
      {value && (
        <GreenStatusButton
          icon={FiCheckCircle}
        >{`${issue?.context?.emailType ? `${titleize(issue?.context?.emailType)} ` : ""}Email Added`}</GreenStatusButton>
      )}
    </Flex>
  );
}

export function missingEmailResolution(issue: IssueDetail): ResolutionInfo {
  const { user } = issue || {};

  return {
    issueType: "missing_email",
    tagText: `Missing ${user?.fullName || "user"}'s ${titleize(issue?.context?.emailType)} Email`,
    title: `Missing ${user?.fullName || "user"}'s ${titleize(issue?.context?.emailType)} Email`,

    additionalContext: `Cannot find ${user?.fullName}'s ${titleize(issue?.context?.emailType)} Email to deliver the email. Please add or update their ${titleize(issue?.context?.emailType)} Email.`,
    inputComponent: IssueModalInputFields,
  };
}
